import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/use-auth';
import { useUserSettingsStore } from '../stores/user-settings';
import { useTranslation } from '../i18n/hooks';

export function AdminRoute() {
  const { isAdmin, isLoggedIn } = useAuth();
  const addPendingToast = useUserSettingsStore((state) => state.addPendingToast);
  const { t } = useTranslation('errors');

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin()) {
    // Add pending toast before navigation
    addPendingToast({
      title: t('access.admin.title'),
      description: t('access.admin.description'),
      variant: 'destructive',
      duration: 8000,
    });
    
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}